/**
 * Filter a FileList returning a new FileList containing all files that pass the callback.
 * @param {FileList} files
 * @param {(file: File, index: number) => boolean} callback
 * @returns {FileList}
 */
const filterFileList = ( files, callback ) => {
    if ( files instanceof FileList ) {
        const tmp = new DataTransfer();
        return Array.from( files ).reduce( ( data, file, index ) => {
            if ( callback( file, index ) ) data.items.add( file );
            return data;
        }, tmp ).files;
    }
    return null;
};

export default filterFileList;